module.exports = __webpack_public_path__ + "static/media/image-8.0cdbdc2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-8.jpg
// module id = 285
// module chunks = 0